import { AxiosResponse } from 'axios';

export const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();
};

export const base64StringToBlob = (data: string, mimeType?: string) => {
  const byteCharacters = atob(data);
  let bytes = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = byteCharacters.charCodeAt(i);
  }
  return new Blob([bytes], mimeType ? { type: mimeType } : undefined);
};

export const getDownloadFileName = (res: AxiosResponse) => {
  const fileName = res?.headers?.['content-disposition']
    ?.split('filename=')?.[1]
    ?.split(';')?.[0]
    ?.replaceAll('"', '');
  return fileName;
};

export const downloadTestFile = async (blob, fileName) => {
  const a = document.createElement('a');
  a.href = blob;
  a.download = fileName;
  a.click();
  a.remove();
};
